import { BADGE1_TYPE, BADGE_TYPE, BRUSH_TYPE, CUSTOM_SET_TYPE, DASHED_FRAME_TYPE, EXTERNAL_IMAGE_SOURCE_TYPE, FRAME_TYPE } from "shape-entities/types/shape"
import ExternalImageForm from './external-image-form';
import BrushForm from "./brush-form"
import CustomSetForm from "./custom-set-form"
import FrameForm from "./frame-form";
import React from "react";

const ShapeSpecificFormBefore = ({ formName, change, shape, shapes, templateSize, activeShapeId, setActiveShapeId }): JSX.Element => {
    switch (shape?.type) {
        case DASHED_FRAME_TYPE:
        case FRAME_TYPE:
            return <FrameForm formName={formName} isDashed={shape.type === DASHED_FRAME_TYPE} shape={shape} />
        case EXTERNAL_IMAGE_SOURCE_TYPE:
        case BADGE_TYPE:
        case BADGE1_TYPE:
            return <ExternalImageForm
                formName={formName}
                change={change}
                shape={shape}
                templateSize={templateSize}
            />
        case BRUSH_TYPE:
            return <BrushForm formName={formName} shape={shape} />
        case CUSTOM_SET_TYPE:
            return <CustomSetForm formName={formName} change={change} shapes={shapes} shape={{ file: '', ...shape }} setActiveShapeId={setActiveShapeId} activeShapeId={activeShapeId} />
        default:
            return <div />
    }
}

export default ShapeSpecificFormBefore